import React, { useMemo } from "react";
import Dropzone from "react-dropzone";
import {Alert, Table} from "react-bootstrap";
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBan,
  faCheck,
  faCircleNotch
} from "@fortawesome/free-solid-svg-icons";

class FileUploadTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      files: [],
    };

    this.allowedDisplayableFormats = ["application/pdf"];

    this.baseStyle = {
      flex: 1,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: "20px",
      borderWidth: 2,
      borderRadius: 2,
      borderColor: "#eeeeee",
      borderStyle: "dashed",
      backgroundColor: "#fafafa",
      color: "#bdbdbd",
      outline: "none",
      transition: "border .24s ease-in-out",
    };

    this.activeStyle = {
      borderColor: "#2196f3",
    };

    this.acceptStyle = {
      borderColor: "#00e676",
    };

    this.rejectStyle = {
      borderColor: "#ff1744",
    };

    this.handleUpload = this.handleUpload.bind(this);
    this.handleHide = this.handleHide.bind(this);
    this.humanReadableFileSize = this.humanReadableFileSize.bind(this);
  }

  handleHide() {
    this.props.onHide();
  }

  async handleUpload(files) {
    files = files.map((f) => {
      f["status"] = 0;
      return f;
    });
    this.setState({ files });
    const uploadedFiles = await this.props.onUpload(files);
    this.setState({ uploadedFiles });
  }

  humanReadableFileSize(size) {
    const labels = ["B", "KB", "MB", "GB"];
    let ct = 0;
    while (size > 1024 && ct < labels.length) {
      size /= 1024;
      ct++;
    }
    return `${Math.round(size * 100) / 100} ${labels[ct]}`;
  }

  render() {
    const { t } = this.props;
    const fileState = [
      <FontAwesomeIcon
        key={1}
        icon={faCircleNotch}
        pulse
        className="color-black mr-2"
      />,
      <FontAwesomeIcon key={2} icon={faCheck} className="color-green mr-2" />,
      <FontAwesomeIcon key={3} icon={faBan} className="color-red mr-2" />,
    ];
    return (
      <div className="mt-2">
        {this.props.dialogApiError}
        {this.props.instanceTemplate.type === 2
        || (this.props.instanceTemplate.type === 1
            && (this.props.examination.securityLevel === 5 || this.props.examination.securityLevel === 6)) ? (
            <Alert key="2" variant="warning">
              <b>
                {t(
                    "SingleExamination.InstanceTab.StudentExaminationFilesDialog.FileUploadTab.AllowedFileTypes"
                )}
                :</b> PDF (.pdf)
            </Alert>
        ) : ""}
        <Dropzone
            accept={this.props.examination.instanceTemplate.type === 2
            || (this.props.examination.instanceTemplate.type === 1
                && (this.props.examination.securityLevel === 5 || this.props.examination.securityLevel === 6)
            ) ? this.allowedDisplayableFormats : ""}
            onDrop={this.handleUpload}
        >
          {({
            getRootProps,
            getInputProps,
            isDragActive,
            isDragAccept,
            isDragReject,
          }) => {
            const style = useMemo(
              () => ({
                ...this.baseStyle,
                ...(isDragActive ? this.activeStyle : {}),
                ...(isDragAccept ? this.acceptStyle : {}),
                ...(isDragReject ? this.rejectStyle : {}),
              }),
              [isDragActive, isDragReject, isDragAccept]
            );

            return (
              <section className="container mt-2 pl-0 pr-0">
                <div {...getRootProps({ style })}>
                  <input {...getInputProps()} />
                  <p>
                    {" "}
                    {t(
                      "SingleExamination.InstanceTab.StudentExaminationFilesDialog.FileUploadTab.DragNDropBody"
                    )}
                  </p>
                </div>
                <aside>
                  {this.state.files.length === 0 ? (
                      <div className="mt-3">
                        <h5>
                          {t(
                              "SingleExamination.InstanceTab.StudentExaminationFilesDialog.FileUploadTab.Files"
                          )}
                        </h5>
                        <div>
                          <FontAwesomeIcon icon={faCheck} className="color-green mr-2" />
                          {t("SingleExamination.InstanceTab.StudentExaminationFilesDialog.FileUploadTab.SuccessfulUpload")}
                          <br />
                          <FontAwesomeIcon icon={faBan} className="color-red mr-2" />
                          {t("SingleExamination.InstanceTab.StudentExaminationFilesDialog.FileUploadTab.FailedUpload")}
                        </div>
                        <div className="mt-2">
                          <b>
                            {t("SingleExamination.InstanceTab.StudentExaminationFilesDialog.FileUploadTab.NoFilesUploaded")}
                          </b>
                        </div>
                      </div>
                  ) : (
                      <div className="mt-3">
                        <h5>
                          {t(
                              "SingleExamination.InstanceTab.StudentExaminationFilesDialog.FileUploadTab.Files"
                          )}
                        </h5>
                        <div>
                          <FontAwesomeIcon icon={faCheck} className="color-green mr-2" />
                          {t("SingleExamination.InstanceTab.StudentExaminationFilesDialog.FileUploadTab.SuccessfulUpload")}
                          <br />
                          <FontAwesomeIcon icon={faBan} className="color-red mr-2" />
                          {t("SingleExamination.InstanceTab.StudentExaminationFilesDialog.FileUploadTab.FailedUpload")}
                        </div>
                        <Table size="sm" className="mt-2">
                          <thead>
                          <tr>
                            <th>
                              {t("SingleExamination.InstanceTab.StudentExaminationFilesDialog.FileUploadTab.ColumnFilename")}
                            </th>
                            <th>
                              {t("SingleExamination.InstanceTab.StudentExaminationFilesDialog.FileUploadTab.ColumnSize")}
                            </th>
                            <th></th>
                          </tr>
                          </thead>
                          <tbody>
                          {this.state.files.map((f, idx) => (
                              <tr key={idx} >
                                <td style={f.status === 2 ? {backgroundColor: "#F88484"} : {}}>
                                  <b>{f.name}</b>
                                </td>
                                <td style={f.status === 2 ? {backgroundColor: "#F88484"} : {}}>
                                  <b>{this.humanReadableFileSize(f.size)}</b>
                                </td>
                                <td style={{textAlign: "center"}}>{fileState[f.status]}</td>
                              </tr>
                          ))}
                          </tbody>
                        </Table>
                      </div>
                  )}
                </aside>
              </section>
            );
          }}
        </Dropzone>
      </div>
    );
  }
}

export default withTranslation()(FileUploadTab);
